import axios from "axios";
import Cookies from "js-cookie";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Generic API request function
const fetchData = async (url, params = {}) => {
  const token = Cookies.get("auth_token");
  try {
    const response = await axios.get(`${API_BASE_URL}${url}`, {
      params: { ...params },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.status === "Success" ? response.data.data : null;
  } catch (error) {
    console.error(`Error fetching ${url}:`, error);
    return null;
  }
};

// Export function for reuse
export default fetchData;
